import React, { useCallback, useState } from 'react';

type ToggleBooleanState = () => void;
type SetBooleanState = React.Dispatch<React.SetStateAction<boolean>>;

const useBooleanState = (
  initialState: boolean
): [boolean, ToggleBooleanState, SetBooleanState] => {
  const [state, setState] = useState(initialState);

  const toggleState: ToggleBooleanState = useCallback(() => {
    setState((currState) => !currState);
  }, [setState]);

  return [state, toggleState, setState];
};

export default useBooleanState;
